import { useCallback, useEffect, useState } from "react";
import { AppInputBase } from "../../../../../../../shared/components/AppInputBase";
import { TValueForService } from "../../../../../../../services/api/instances/storageApi/types/service_types";
import { useTranslation } from "react-i18next";
import { NormalizedStorageObject } from "../../../../../../../services/api/instances/storageApi/types/object_types";
import { ChatbotValue } from "../../../../../../../services/api/instances/botApi/types";
import { getUpdatedChatbotValue } from "../../../../../helpers/getUpdatedChatbotValue";
import styles from "./styles.module.css";
import { useAppSelector } from "../../../../../../../services/redux/hooks/use-selector";
import { selectedLangSelector } from "../../../../../../../services/i18n/redux/selectors";

interface Props {
  selectedObject: NormalizedStorageObject<ChatbotValue> | null;
  inputPlaceholder: string;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const StartMessageInput = (props: Props) => {
  const { t } = useTranslation();
  const selectedLang = useAppSelector(selectedLangSelector);
  const [startMessage, setStartMessage] = useState<string>(
    t("chatbot.default_welcome_message"),
  );

  useEffect(() => {
    if (!props.selectedObject?.value?.tg_bot_object) return;
    const message = props.selectedObject.value.tg_bot_object.start_message;
    setStartMessage(message ?? "");
  }, [props.selectedObject?.id, selectedLang]);

  const handleChangeStartMessage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setStartMessage(event.target.value);
  };

  const handleChangeBotStartMessage = useCallback(() => {
    if (!props.selectedObject?.value?.tg_bot_object) return;
    const updatedValue = getUpdatedChatbotValue(props.selectedObject.value, {
      start_message: startMessage,
    });
    props.saveChatbotValue(updatedValue);
  }, [props.selectedObject?.id, startMessage]);

  return (
    <AppInputBase
      className={styles["input-base"]}
      value={startMessage}
      onChange={handleChangeStartMessage}
      onBlur={handleChangeBotStartMessage}
      rows={4}
      placeholder={props.inputPlaceholder}
    />
  );
};
